var _templateObject = _taggedTemplateLiteralLoose(['\n  padding:', ';\n  border-radius: 10px;\n  box-shadow: -1px 0px 3px 0px ', '\n  display: flex;\n  flex-direction:row;\n  overflow: hidden;\n  @media(max-width: 767px){\n    flex-direction: column-reverse;\n    padding: 0px;\n    margin: 0px  ', ';\n  }\n  .detail{\n    display: flex;\n    flex:4;\n    flex-direction: column;\n    padding: 0px ', ';\n    @media(max-width: 767px){\n      padding-top: ', ';\n    }\n  }\n\n  .image-container{\n    .image{\n      background: url(', ') no-repeat center center;\n      background-size: cover;\n      border-radius: 50%;\n      width: ', ';\n      height: ', ';\n      @media(max-width: 767px){\n        border-radius: 0%;\n        width: 100%;\n        height:200px;\n      }\n    }\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex:1;\n    border-left: 1px solid #ccd4d742;\n    padding:', ';\n    @media(max-width: 767px){\n      padding:0px;\n    }\n  }\n'], ['\n  padding:', ';\n  border-radius: 10px;\n  box-shadow: -1px 0px 3px 0px ', '\n  display: flex;\n  flex-direction:row;\n  overflow: hidden;\n  @media(max-width: 767px){\n    flex-direction: column-reverse;\n    padding: 0px;\n    margin: 0px  ', ';\n  }\n  .detail{\n    display: flex;\n    flex:4;\n    flex-direction: column;\n    padding: 0px ', ';\n    @media(max-width: 767px){\n      padding-top: ', ';\n    }\n  }\n\n  .image-container{\n    .image{\n      background: url(', ') no-repeat center center;\n      background-size: cover;\n      border-radius: 50%;\n      width: ', ';\n      height: ', ';\n      @media(max-width: 767px){\n        border-radius: 0%;\n        width: 100%;\n        height:200px;\n      }\n    }\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex:1;\n    border-left: 1px solid #ccd4d742;\n    padding:', ';\n    @media(max-width: 767px){\n      padding:0px;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { textSizes, getImageDimension } from './config';
export var TestimonialContainer = styled.div(_templateObject, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.theme.colours.neutral.light;
}, function (props) {
  return props.theme.spaces.extraTight;
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.theme.spaces.loose;
}, function (props) {
  return props.imageUrl;
}, function (props) {
  return getImageDimension(props.size);
}, function (props) {
  return getImageDimension(props.size);
}, function (props) {
  return props.theme.spaces.tight;
});

var SimpleTestimonial = function SimpleTestimonial(_ref) {
  var name = _ref.name,
      detail = _ref.detail,
      imageUrl = _ref.imageUrl,
      size = _ref.size;
  var detailClass = textSizes[size].fontSizeClass;
  return React.createElement(TestimonialContainer, {
    imageUrl: imageUrl,
    size: size
  }, React.createElement('div', {
    className: 'detail'
  }, textSizes[size].renderHeading(name), React.createElement('p', {
    className: detailClass
  }, detail)), React.createElement('div', {
    className: 'image-container'
  }, React.createElement('div', {
    className: 'image'
  })));
};

var TESTIMONIAL_TYPES = {
  'simple': SimpleTestimonial
};

var Testimonial = function (_Component) {
  _inherits(Testimonial, _Component);

  function Testimonial() {
    _classCallCheck(this, Testimonial);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Testimonial.prototype.render = function render() {
    var type = this.props.type;
    var TestimonialComponent = TESTIMONIAL_TYPES[type];

    if (TestimonialComponent) {
      return React.createElement(TestimonialComponent, this.props);
    } else {
      throw "Unknown Testimonial Type";
    }
  };

  return Testimonial;
}(Component);

export default Testimonial;